import { render, staticRenderFns } from "./mailjet.vue?vue&type=template&id=35141788&scoped=true"
import script from "./mailjet.vue?vue&type=script&lang=js"
export * from "./mailjet.vue?vue&type=script&lang=js"
import style0 from "./mailjet.vue?vue&type=style&index=0&id=35141788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35141788",
  null
  
)

export default component.exports